import { render, staticRenderFns } from "./MenuContabilita.vue?vue&type=template&id=685b4e08&scoped=true&"
import script from "./MenuContabilita.vue?vue&type=script&lang=js&"
export * from "./MenuContabilita.vue?vue&type=script&lang=js&"
import style0 from "./MenuContabilita.vue?vue&type=style&index=0&id=685b4e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b4e08",
  null
  
)

export default component.exports